import { apiAuthClient } from 'shared/api/lib';

import type {
  GetNotificationHintRequestType,
  GetNotificationHintResponseType,
} from '../types';

export const getNotificationHint = async ({
  pathParams: { notificationId },
}: GetNotificationHintRequestType) => {
  const url = `/api/v2/notifications/${notificationId}/hint`;

  const { data } =
    await apiAuthClient.get<GetNotificationHintResponseType>(url);

  return data.data;
};
